(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3920],{

/***/ 3920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CoursePageSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./components/CoursePageSection/CoursePageSection.module.scss
var CoursePageSection_module = __webpack_require__(18564);
var CoursePageSection_module_default = /*#__PURE__*/__webpack_require__.n(CoursePageSection_module);
// EXTERNAL MODULE: ./node_modules/react-tabs/esm/index.js + 10 modules
var esm = __webpack_require__(78369);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./common/interfaces/api.ts
var api = __webpack_require__(21694);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
// EXTERNAL MODULE: ./components/common/Icon/index.tsx
var Icon = __webpack_require__(37975);
// EXTERNAL MODULE: ./components/common/InfiniteScroll/index.tsx
var InfiniteScroll = __webpack_require__(68330);
// EXTERNAL MODULE: ./components/CoursesList/CoursesList.module.scss
var CoursesList_module = __webpack_require__(10560);
var CoursesList_module_default = /*#__PURE__*/__webpack_require__.n(CoursesList_module);
// EXTERNAL MODULE: ./components/common/PreloadContentLoader/index.tsx + 1 modules
var PreloadContentLoader = __webpack_require__(60782);
// EXTERNAL MODULE: ./service/course.ts
var course = __webpack_require__(11038);
// EXTERNAL MODULE: ./components/common/CourseItemView/CourseItemView.module.scss
var CourseItemView_module = __webpack_require__(40057);
var CourseItemView_module_default = /*#__PURE__*/__webpack_require__.n(CourseItemView_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/common/UserInfo/index.tsx
var UserInfo = __webpack_require__(92371);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/common/CourseRatingView/index.tsx
var CourseRatingView = __webpack_require__(89261);
// EXTERNAL MODULE: ./lib/dayjs.ts
var dayjs = __webpack_require__(25916);
// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 164 modules
var lib_esm = __webpack_require__(38367);
;// CONCATENATED MODULE: ./components/common/CourseItemView/index.tsx










function CourseItemView(param) {
    var course = param.course;
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var userInfoRef = (0,react.useRef)(null);
    var onCourseClick = function(e) {
        var ref;
        var selection = window.getSelection();
        if (selection.type != "Range" && !(userInfoRef === null || userInfoRef === void 0 ? void 0 : (ref = userInfoRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
            var ref1;
            (0,lib_esm/* track */.j)("View Course", {
                course_id: (ref1 = course.id) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                course_name: course.title
            });
            void router.push("/courses/".concat(course.id));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CourseItemView_module_default()).courseItemView,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CourseItemView_module_default()).thumbnailWrapper,
                children: ((ref = course.thumbnail_image_media) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/courses/".concat(course.id),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        onClick: function() {
                            var ref;
                            (0,lib_esm/* track */.j)("View Course", {
                                course_id: (ref = course.id) === null || ref === void 0 ? void 0 : ref.toString(),
                                course_name: course.title
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: course.thumbnail_image_media.url,
                            height: ((ref1 = course.thumbnail_image_media) === null || ref1 === void 0 ? void 0 : ref1.height) * 2,
                            width: ((ref2 = course.thumbnail_image_media) === null || ref2 === void 0 ? void 0 : ref2.width) * 2,
                            alt: "image"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CourseItemView_module_default()).courseInfo,
                onClick: onCourseClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CourseItemView_module_default()).courseInfoHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: userInfoRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfo/* default */.Z, {
                                    user: course.user
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (CourseItemView_module_default()).timeSince,
                                children: course.published_at && (0,dayjs/* default */.Z)(course.published_at).format("YYYY年MM月")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CourseItemView_module_default()).courseInfoBody,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CourseItemView_module_default()).courseTitle,
                                children: course.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CourseItemView_module_default()).ratingAndCategory,
                                children: [
                                    course.domains && course.domains.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (CourseItemView_module_default()).categoryItem,
                                        children: course.domains[0].name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseRatingView/* default */.Z, {
                                        count: (ref3 = course.review_summary) === null || ref3 === void 0 ? void 0 : ref3.count,
                                        rating: (ref4 = course.review_summary) === null || ref4 === void 0 ? void 0 : ref4.rating,
                                        className: (CourseItemView_module_default()).ratingSection
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CourseItemView_module_default()).description,
                                children: course.description
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var MemoizedCourseItem = /*#__PURE__*/ react.memo(CourseItemView);
/* harmony default export */ var common_CourseItemView = (MemoizedCourseItem);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/CoursesList/index.tsx






// import useStore from 'store/timeline';








var ALL_CATEGORY_ID = 0;
function CoursesList(param) {
    var disableInfiniteScroll = param.disableInfiniteScroll, noResultMessage = param.noResultMessage, _showCategory = param.showCategory, showCategory = _showCategory === void 0 ? false : _showCategory;
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), isMounted = ref3[0], setIsMounted = ref3[1];
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var ref4 = (0,react.useState)([]), categories = ref4[0], setCategories = ref4[1];
    var ref5 = (0,react.useState)(ALL_CATEGORY_ID), currentCategoryId = ref5[0], setCurrentCategoryId = ref5[1];
    (0,react.useEffect)(function() {
        // FIXME: this is a hack to prevent call api 2 times in first render
        var timeout = setTimeout(function() {
            setIsMounted(true);
        }, 100);
        return function() {
            clearTimeout(timeout);
        };
    }, []);
    var ref6 = (0,es.useInfiniteQuery)([
        "getCoursesList",
        currentCategoryId
    ], function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _pageParam, pageParam;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? "1" : _pageParam;
                        if (!(!isAuthInit || !isMounted)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject());
                    case 3:
                        _ctx.next = 5;
                        return (0,course/* getCoursesList */.CA)({
                            domainId: currentCategoryId,
                            nextKey: pageParam
                        });
                    case 5:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: function(lastPage) {
            var ref, ref1;
            var courses = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.courses;
            if (courses && courses.length > 0 && (lastPage === null || lastPage === void 0 ? void 0 : (ref1 = lastPage.data) === null || ref1 === void 0 ? void 0 : ref1.next_key)) {
                var ref2;
                return lastPage === null || lastPage === void 0 ? void 0 : (ref2 = lastPage.data) === null || ref2 === void 0 ? void 0 : ref2.next_key;
            }
        },
        // TODO: somehow enabled is not working as intended
        // useInfiniteQuery still runs when enabled is false
        // this is currently handled by only shows this component when isAuthInit is true
        enabled: isAuthInit && isMounted,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000
    }), isLoading = ref6.isLoading, data = ref6.data, fetchNextPage = ref6.fetchNextPage, isFetchingNextPage = ref6.isFetchingNextPage, isFetched = ref6.isFetched;
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        var domains = (data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.domains) || [];
        if (domains.length > 0 && domains.length !== categories.length) {
            setCategories(domains);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.domains
    ]);
    var courses = (0,react.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var ref;
            return curr.concat(((ref = page.data) === null || ref === void 0 ? void 0 : ref.courses) || []);
        }, []) : [];
    }, [
        pages
    ]);
    var noPostPlaceholder;
    if (!isLoading && courses.length === 0) {
        noPostPlaceholder = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CoursesList_module_default()).noCourse,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "empty",
                    width: 96,
                    height: 96
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: noResultMessage
                    }
                })
            ]
        });
    }
    var coursesRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: courses.map(function(course, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_CourseItemView, {
                course: course
            }, "".concat(course === null || course === void 0 ? void 0 : course.id, "-").concat(index));
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CoursesList_module_default()).coursesListWrapper,
        children: [
            showCategory && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CoursesList_module_default()).categories,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()((CoursesList_module_default()).categoryItem, (0,_define_property/* default */.Z)({}, (CoursesList_module_default()).active, currentCategoryId === ALL_CATEGORY_ID)),
                        onClick: function() {
                            return setCurrentCategoryId(ALL_CATEGORY_ID);
                        },
                        children: "全て"
                    }),
                    categories.map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()((CoursesList_module_default()).categoryItem, (0,_define_property/* default */.Z)({}, (CoursesList_module_default()).active, currentCategoryId === category.id)),
                            onClick: function() {
                                return setCurrentCategoryId(category.id);
                            },
                            children: category.name
                        }, "category-".concat(category.id));
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                fetchNextPage: fetchNextPage,
                disabled: disableInfiniteScroll,
                isLoading: isFetchingNextPage,
                children: isFetched ? coursesRender : /*#__PURE__*/ (0,jsx_runtime.jsx)(PreloadContentLoader/* PostsLoader */.DN, {})
            }),
            noPostPlaceholder
        ]
    });
};

// EXTERNAL MODULE: ./store/timeline.ts
var timeline = __webpack_require__(12800);
// EXTERNAL MODULE: ./components/common/Button/index.tsx
var Button = __webpack_require__(98133);
// EXTERNAL MODULE: ./components/PurchasedCoursesList/CoursesList.module.scss
var PurchasedCoursesList_CoursesList_module = __webpack_require__(75107);
var PurchasedCoursesList_CoursesList_module_default = /*#__PURE__*/__webpack_require__.n(PurchasedCoursesList_CoursesList_module);
;// CONCATENATED MODULE: ./components/PurchasedCoursesList/index.tsx





// import useStore from 'store/timeline';







function PurchasedCoursesList(param) {
    var disableInfiniteScroll = param.disableInfiniteScroll, noResultMessage = param.noResultMessage;
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var ref = (0,es.useInfiniteQuery)([
        "getPurchasedCoursesList"
    ], function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var _pageParam, pageParam;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
                        if (isAuthInit) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject());
                    case 3:
                        _ctx.next = 5;
                        return (0,course/* getPurchasedCoursesList */.ov)(pageParam);
                    case 5:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: function(lastPage, pages) {
            var ref;
            var courses = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.courses;
            if (courses && courses.length > 0) {
                return pages.length + 1;
            }
        },
        // TODO: somehow enabled is not working as intended
        // useInfiniteQuery still runs when enabled is false
        // this is currently handled by only shows this component when isAuthInit is true
        enabled: isAuthInit,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        cacheTime: 15 * 60 * 1000
    }), isLoading = ref.isLoading, data = ref.data, fetchNextPage = ref.fetchNextPage, isFetchingNextPage = ref.isFetchingNextPage, isFetched = ref.isFetched;
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    var courses = (0,react.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var ref;
            return curr.concat(((ref = page.data) === null || ref === void 0 ? void 0 : ref.courses) || []);
        }, []) : [];
    }, [
        pages
    ]);
    var noPostPlaceholder;
    if (!isLoading && courses.length === 0) {
        noPostPlaceholder = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PurchasedCoursesList_CoursesList_module_default()).noCourse,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "empty",
                    width: 96,
                    height: 96
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: noResultMessage
                    }
                })
            ]
        });
    }
    var coursesRender = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: courses.map(function(course, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_CourseItemView, {
                course: course
            }, "".concat(course === null || course === void 0 ? void 0 : course.id, "-").concat(index));
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PurchasedCoursesList_CoursesList_module_default()).coursesListWrapper,
        children: [
            noPostPlaceholder,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                fetchNextPage: fetchNextPage,
                disabled: disableInfiniteScroll,
                isLoading: isFetchingNextPage,
                children: isFetched ? coursesRender : /*#__PURE__*/ (0,jsx_runtime.jsx)(PreloadContentLoader/* PostsLoader */.DN, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/common/LinkButton/index.tsx
var LinkButton = __webpack_require__(22396);
;// CONCATENATED MODULE: ./components/CoursePageSection/index.tsx



















function CoursePageSection(param) {
    var children = param.children;
    var isMobile = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var router = (0,next_router.useRouter)();
    var isCourseIndexPage = router.pathname === "/courses";
    var tab = router.query.tab;
    var ref = (0,react.useState)(function() {
        if (tab === api/* CoursePageTab.AllCourses */.nE.AllCourses) {
            return 0;
        } else if (tab === api/* CoursePageTab.MyCourses */.nE.MyCourses) {
            return 1;
        } else {
            return 0;
        }
    }), selectedTab = ref[0], setSelectedTab = ref[1];
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    (0,react.useEffect)(function() {
        if (tab === api/* CoursePageTab.AllCourses */.nE.AllCourses) {
            setSelectedTab(0);
        } else if (tab === api/* CoursePageTab.MyCourses */.nE.MyCourses) {
            setSelectedTab(1);
        } else {
            setSelectedTab(0);
        }
    }, [
        tab
    ]);
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref1 = (0,es.useMutation)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,course/* createBlankCourse */.X1)();
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        onSuccess: function(data) {
            var ref;
            setSnackbarMessage({
                type: "success",
                text: "新しいコースを作成しました"
            });
            var newCourseId = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.id;
            if (newCourseId) {
                void router.push("/dashboard/my_courses/".concat(newCourseId));
            } else {
                setSnackbarMessage({
                    type: "error",
                    text: "エラーが発生しました"
                });
            }
        },
        onError: function() {
            setSnackbarMessage({
                type: "error",
                text: "エラーが発生しました"
            });
        }
    }), createCourse = ref1.mutate, isCreatingCourse = ref1.isLoading;
    var createCourseClick = function() {
        if (!currentUser) {
            showLogin({});
            return;
        }
        createCourse();
    };
    var updateTabParam = (0,react.useCallback)(function(i) {
        var tab;
        if (i === 0) {
            tab = api/* CoursePageTab.AllCourses */.nE.AllCourses;
        } else if (i === 1) {
            tab = api/* CoursePageTab.MyCourses */.nE.MyCourses;
        }
        if (tab) {
            void router.push({
                pathname: "/courses",
                query: {
                    tab: tab
                }
            }, "/courses?tab=".concat(tab), {
                shallow: true
            });
        }
    }, [
        router
    ]);
    var handleSelectTab = function(i) {
        updateTabParam(i);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (CoursePageSection_module_default()).mainSectionWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CoursePageSection_module_default()).courseSectionContentWrapper,
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((CoursePageSection_module_default()).coursePageWrapper, (0,_define_property/* default */.Z)({}, (CoursePageSection_module_default()).hidden, !isCourseIndexPage)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Tabs, {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        selectedTabClassName: (CoursePageSection_module_default()).selected,
                        selectedIndex: selectedTab,
                        onSelect: handleSelectTab,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.TabList, {
                                className: (CoursePageSection_module_default()).courseContentTabs,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Tab, {
                                        className: (CoursePageSection_module_default()).tab,
                                        id: "allCourses",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (CoursePageSection_module_default()).tabContent,
                                            children: "全てのコース"
                                        })
                                    }),
                                    currentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Tab, {
                                        className: (CoursePageSection_module_default()).tab,
                                        id: "myCourses",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (CoursePageSection_module_default()).tabContent,
                                            children: "購入済みコース"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (CoursePageSection_module_default()).addCourseSection,
                                        children: [
                                            !isMobile && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.is_create_course_able) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* default */.Z, {
                                                        text: "マイコース一覧",
                                                        onClick: function() {
                                                            void router.push("/dashboard/my_courses");
                                                        },
                                                        marginRight: 15,
                                                        fontSize: 13
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        text: "コースを作成",
                                                        onClick: function() {
                                                            return createCourseClick();
                                                        },
                                                        isLoading: isCreatingCourse,
                                                        disabled: isCreatingCourse
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: utils/* COURSE_HELP_URL */.m3,
                                                target: "_blank",
                                                className: (CoursePageSection_module_default()).helpIcon,
                                                rel: "noopener",
                                                children: "?"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.TabPanel, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CoursePageSection_module_default()).tabContentWrapper,
                                    children: isAuthInit && /*#__PURE__*/ (0,jsx_runtime.jsx)(CoursesList, {
                                        disableInfiniteScroll: false,
                                        showCategory: true,
                                        noResultMessage: "コースはまだありません"
                                    })
                                })
                            }),
                            currentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.TabPanel, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CoursePageSection_module_default()).tabContentWrapper,
                                    children: isAuthInit && /*#__PURE__*/ (0,jsx_runtime.jsx)(PurchasedCoursesList, {
                                        disableInfiniteScroll: false,
                                        noResultMessage: "現在、購入済みのコースはありません。<br/>気になるコースを購入して学びましょう！"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 18564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mainSectionWrapper":"CoursePageSection_mainSectionWrapper__p9XpA","courseSectionContentWrapper":"CoursePageSection_courseSectionContentWrapper__NtqzR","coursePageWrapper":"CoursePageSection_coursePageWrapper__Gu9v9","hidden":"CoursePageSection_hidden__Op0wF","tabContentWrapper":"CoursePageSection_tabContentWrapper__EmMU7","courseContentTabs":"CoursePageSection_courseContentTabs__f9wvb","tab":"CoursePageSection_tab__0jblH","tabContent":"CoursePageSection_tabContent__ewaXD","selected":"CoursePageSection_selected___XKiX","addCourseSection":"CoursePageSection_addCourseSection__Uzwx5","helpIcon":"CoursePageSection_helpIcon__OFFAJ"};

/***/ }),

/***/ 10560:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"coursesListWrapper":"CoursesList_coursesListWrapper__ZsIq9","noCourse":"CoursesList_noCourse__MNayZ","categories":"CoursesList_categories__QiAWk","categoryItem":"CoursesList_categoryItem__iFrGW","active":"CoursesList_active__Se6CF"};

/***/ }),

/***/ 75107:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"coursesListWrapper":"CoursesList_coursesListWrapper__0_k2G","noCourse":"CoursesList_noCourse__TAKQy"};

/***/ }),

/***/ 40057:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"courseItemView":"CourseItemView_courseItemView__ycIIO","thumbnailWrapper":"CourseItemView_thumbnailWrapper__EIRYY","courseInfo":"CourseItemView_courseInfo__P_DoA","courseInfoHeader":"CourseItemView_courseInfoHeader__sruiV","timeSince":"CourseItemView_timeSince__LUegc","courseInfoBody":"CourseItemView_courseInfoBody__tW6Tf","courseTitle":"CourseItemView_courseTitle__C20mF","ratingAndCategory":"CourseItemView_ratingAndCategory__qKDAn","ratingSection":"CourseItemView_ratingSection__xxL5X","categoryItem":"CourseItemView_categoryItem__OJQc2","description":"CourseItemView_description__DuWfQ"};

/***/ })

}]);